/* Honest-outcome classification.
 *
 * This is a licence condition, not a presentation preference (CLAUDE.md §5):
 * a payout below the stake must read as a partial return, a payout equal to
 * the stake must read as the card being covered, and only a genuine profit may
 * be celebrated. It lived inline in finish() where it could not be tested
 * without a DOM; it is a pure function of two numbers, so it lives here now
 * and is covered by test/outcome.test.ts.
 *
 * Do not add a branch that celebrates a non-profit outcome. */

export type OutcomeKind = "loss" | "partial" | "covered" | "profit";

export interface Outcome {
  kind: OutcomeKind;
  /** true for anything that is not a profit — must never be celebrated. */
  quiet: boolean;
  /** payout as a multiple of the stake */
  mult: number;
  /** payout minus stake; negative on a partial return */
  net: number;
}

export function classifyOutcome(prize: number, price: number): Outcome {
  const mult = price > 0 ? prize / price : 0;
  const net = prize - price;

  const kind: OutcomeKind =
    prize <= 0 ? "loss" :
    mult < 1   ? "partial" :
    mult === 1 ? "covered" :
                 "profit";

  return { kind, quiet: kind !== "profit", mult, net };
}
